import { InjectionKey } from "vue";
type ChangeUserNameType = () => void;
export const resetRouter: InjectionKey<ChangeUserNameType> = Symbol();
